import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import App from 'modules/App';
import Information from 'modules/Information';
import { renderLegalConsentField } from '../renderers';
const SensitiveDataConsents = ()=>{
    const consentsTemplate = useSelector(Information.selectors.consentsTemplate);
    const isMobileDisplayMode = useSelector(App.selectors.isMobileDisplayMode);
    const sensitiveDataConsents = consentsTemplate.filter((consent)=>consent.type === 'SensitiveDataAndProfiling');
    if (isMobileDisplayMode || !sensitiveDataConsents.length) {
        return null;
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: sensitiveDataConsents.map(renderLegalConsentField)
    });
};
export default SensitiveDataConsents;
